/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".to-the-right[_ngcontent-%COMP%] {\n  right: 8px !important; }"];
export { styles as styles };
